(() => {
  const menus = document.querySelectorAll('.ep-mobile-menu, .ep-search-menu, .ep-shop-menu');
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (!menu.open) return;
    menus.forEach(other => { if (other !== menu) other.removeAttribute('open'); });
    if (menu.classList.contains('ep-search-menu')) menu.querySelector('input[type="search"]')?.focus();
  }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = [...menus].find(menu => menu.open);
    if (!openMenu) return;
    openMenu.removeAttribute('open');
    openMenu.querySelector('summary')?.focus();
  });
  document.addEventListener('click', event => menus.forEach(menu => { if (!menu.contains(event.target)) menu.removeAttribute('open'); }));
  document.addEventListener('DOMContentLoaded', () => {
    const submit = document.querySelector('.template--product .main-product form[action*="/cart/add"] .add-to-cart-btn[type="submit"]');
    if (!submit || !('IntersectionObserver' in window)) return;
    const bar = document.createElement('div');
    bar.className = 'ep-sticky-purchase';
    bar.hidden = true;
    const title = document.createElement('span');
    title.textContent = document.querySelector('.product__title')?.textContent.trim() || 'EPHIU Sunglasses';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = submit.disabled ? 'Out of Stock' : 'Add to Bag';
    button.disabled = submit.disabled;
    button.addEventListener('click', () => submit.click());
    bar.append(title, button);
    document.body.append(bar);
    let scheduled = false;
    const syncBar = () => {
      scheduled = false;
      const rect = submit.getBoundingClientRect();
      const heading = document.querySelector('.product__title')?.getBoundingClientRect();
      bar.hidden = (rect.top < window.innerHeight && rect.bottom > 0) || !heading || heading.top > window.innerHeight * .8;
    };
    new IntersectionObserver(syncBar).observe(submit);
    window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; window.requestAnimationFrame(syncBar); } }, {passive:true});
    new MutationObserver(() => { button.disabled = submit.disabled; button.textContent = submit.disabled ? 'Out of Stock' : 'Add to Bag'; }).observe(submit, {attributes:true,attributeFilter:['disabled']});
  });
})();
